var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4663",
    "data-name": "Rettangolo 4663",
    width: 22.436,
    height: 26.883,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8511",
    "data-name": "Raggruppa 8511",
    transform: "translate(800 12456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8506",
    "data-name": "Raggruppa 8506",
    transform: "translate(130 389)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4662",
    "data-name": "Rettangolo 4662",
    width: 50,
    height: 50,
    rx: 14,
    transform: "translate(-930 -12845)",
    fill: "#f7bf12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8507",
    "data-name": "Raggruppa 8507",
    transform: "translate(-42.056 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11373",
    "data-name": "Tracciato 11373",
    d: "M159.677,314.233A2.1,2.1,0,0,0,157.759,313h-2.438a2.065,2.065,0,0,0-1.951,1.319c-.041.107-.091.241-.143.4h-5.107a.78.78,0,0,0-.56.237l-1.34,1.38a.78.78,0,0,0,0,1.09l1.365,1.389a.78.78,0,0,0,.556.233h2.535a.78.78,0,0,0,0-1.56h-2.208l-.6-.612.579-.6h5.362a.78.78,0,0,0,.758-.595,6.443,6.443,0,0,1,.257-.8.511.511,0,0,1,.5-.318h2.434a.532.532,0,0,1,.5.309,5.038,5.038,0,0,1,.461,1.989,5.186,5.186,0,0,1-.458,2.024.533.533,0,0,1-.49.319H155.3a.555.555,0,0,1-.5-.345,5.186,5.186,0,0,1-.242-.772.78.78,0,1,0-1.517.363,6.715,6.715,0,0,0,.317,1,2.1,2.1,0,0,0,1.943,1.311h2.467a2.091,2.091,0,0,0,1.918-1.256,6.752,6.752,0,0,0,.588-2.651A6.6,6.6,0,0,0,159.677,314.233Z",
    transform: "translate(-880.433 -12768.729)",
    fill: "#fff",
    stroke: "#f7bf12",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8503",
    "data-name": "Raggruppa 8503",
    transform: "translate(-744.944 -12476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8502",
    "data-name": "Raggruppa 8502",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11376",
    "data-name": "Tracciato 11376",
    d: "M21.895,254.752h.015a.525.525,0,0,0,.487-.723,11.646,11.646,0,0,0-2.938-4.193,3.028,3.028,0,0,0-3.67-.3,7.654,7.654,0,0,1-4.153,1.181,7.654,7.654,0,0,1-4.153-1.181,3.028,3.028,0,0,0-3.67.3A11.662,11.662,0,0,0,0,258.468v1.344a3.054,3.054,0,0,0,3.045,3.045H7.522a.525.525,0,1,0,0-1.05H3.04a2,2,0,0,1-2-2v-1.344a10.625,10.625,0,0,1,3.471-7.855,1.968,1.968,0,0,1,1.328-.515,1.932,1.932,0,0,1,1.061.315,8.691,8.691,0,0,0,4.72,1.349,8.691,8.691,0,0,0,4.72-1.349,1.976,1.976,0,0,1,2.394.2,10.643,10.643,0,0,1,2.669,3.81.528.528,0,0,0,.487.329",
    transform: "translate(0 -235.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11377",
    "data-name": "Tracciato 11377",
    d: "M99.373,13.546a6.773,6.773,0,1,1,6.773-6.773,6.783,6.783,0,0,1-6.773,6.773m0-12.491A5.723,5.723,0,1,0,105.1,6.778a5.723,5.723,0,0,0-5.723-5.723",
    transform: "translate(-87.738)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_780",
    "data-name": "Ellisse 780",
    cx: 0.834,
    cy: 0.834,
    rx: 0.834,
    ry: 0.834,
    transform: "translate(-724.282 -12452.682)",
    fill: "#fff",
    stroke: "#f7bf12",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.2f544251fef914c6f27de70387c7c593.svg";
export { ForwardRef as ReactComponent };